import { useCallback, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { DIAGNOSTICS_DATE_FORMAT } from '@/const';
import { format } from 'date-fns';
import { useLazyGetFullOilReportQuery, useLazyGetOilReportRecapQuery } from '@/store/api/reportsApi';
import { useSelector } from 'react-redux';
import { dateRangePickerSelector } from '@/store/store';
import { useAppFilters } from '@/hooks';
import { ASSETS_TYPE } from '@/types/shared/navigation-tabs.enums';

export const useFetchReports = ({ asset_name, component_id }: any) => {
  const { from, to } = useSelector(dateRangePickerSelector);
  const { assetsType } = useAppFilters();

  const [
    fetchOilReportRecap,
    { data: oilReportRecap, isLoading: isLoadingOilReportRecap, isFetching: isFetchingOilReportRecap },
  ] = useLazyGetOilReportRecapQuery();

  const [fetchFullOilReport, { data: oilReport, isFetching: isLoadingOilReport, isFetching: isFetchingOilReport }] =
    useLazyGetFullOilReportQuery();

  const { siteId } = useParams();
  const [searchParams] = useSearchParams();
  const componentId = searchParams.get('selectedComponent');

  const getOilReportRecap = useCallback(() => {
    const fromDateISO = format(new Date(from), DIAGNOSTICS_DATE_FORMAT);
    const toDateISO = format(new Date(to), DIAGNOSTICS_DATE_FORMAT);
    fetchOilReportRecap(
      {
        site_id: siteId,
        asset_name,
        component_id,
        from_date: fromDateISO,
        to_date: toDateISO,
      },
      true
    )
      .unwrap()
      .catch(() => {});
  }, [componentId, from, to]);

  const getFullOilReport = useCallback(() => {
    const fromDateISO = format(new Date(from), DIAGNOSTICS_DATE_FORMAT);
    const toDateISO = format(new Date(to), DIAGNOSTICS_DATE_FORMAT);
    fetchFullOilReport(
      {
        site_id: siteId,
        asset_name,
        component_id,
        from_date: fromDateISO,
        to_date: toDateISO,
      },
      true
    )
      .unwrap()
      .catch(() => {});
  }, [componentId, from, to]);

  useEffect(() => {
    if (assetsType === ASSETS_TYPE.FIXED) {
      getOilReportRecap();
      getFullOilReport();
    }
  }, [componentId, from, to, assetsType]);

  return {
    oilReport,
    oilReportRecap,
    isLoadingOilReport,
    isLoadingOilReportRecap,
    isFetchingOilReport,
    isFetchingOilReportRecap,
    getFullOilReport,
    getOilReportRecap,
  };
};
